import request from '@/utils/request';

// 分组通邮配置列表
export async function fetchGroupMailConfig(params) {
  return request(`/api/group-mail-config`, {
    removeBlankProperty: true,
    params,
  });
}

// 分组通邮配置列表
export async function exportGroupMailConfig(params) {
  return request(`/api/group-mail-config`, {
    removeBlankProperty: true,
    params,
    headers: {
      export: 'xlsx',
    },
  });
}

export async function exportGroupTagConfig(params) {
  return request(`/api/group-tag-config`, {
    removeBlankProperty: true,
    params,
    headers: {
      export: 'xlsx',
    },
  });
}

// 分组通邮配置分组列表
export async function fetchGroupMailConfigTags() {
  return request(`/api/group-mail-config/tags`, {});
}

// 获取分组通邮配置导入模版
export function fetchGroupMailConfigTemplate() {
  return request(`/api/group-mail-config/template`, {
    method: 'GET',
  });
}
// 导入规则的模板
export function fetchGroupTagConfigTemplate() {
  return request(`/api/group-tag-config/template`, {
    method: 'GET',
  });
}

// 导入分组通邮配置
export function importGroupMailConfig(data) {
  return request(`/api/group-mail-config/import`, {
    method: 'POST',
    data,
  });
}
//导入通邮规则
export function importGroupTagConfig(data) {
  return request(`/api/group-tag-config/import`, {
    method: 'POST',
    data,
  });
}

// 删除分组通邮配置
export function deleteGroupMailConfig(id) {
  return request(`/api/group-mail-config/${id}`, {
    method: 'DELETE',
  });
}

// 删除分组通邮配置
export function batchDeleteGroupMailConfig(data) {
  return request(`/api/group-mail-config`, {
    method: 'DELETE',
    data,
  });
}

// 分组通邮配置分组列表
export async function verifyGroupMailConfigSku(data) {
  return request(`/api/group-mail-config/verify-sku`, {
    method: 'POST',
    data,
  });
}
